import { getCurrentLanguage } from "@/helpers/get-current-langage";
import { kuwaitForecastType } from "@/schemas/kuwait-forecast-schema";
import { useTranslation } from "react-i18next";

export const formatKuwaitWeatherArray = (
	forecastData: kuwaitForecastType | null,
) => {
	const { t } = useTranslation();

	const lang = getCurrentLanguage();

	const prefix = lang === "ar" ? "AR" : "EN";

	return [
		{
			title: t("weatherState"),
			content: [
				{
					title: t("byDay"),
					description: forecastData?.[`weather_state_AM_${prefix}`],
				},
				{
					title: t("byNight"),
					description: forecastData?.[`weather_state_PM_${prefix}`],
				},
			],
		},
		{
			title: t("seaState"),
			content: [
				{
					title: t("byDay"),
					description: "Slight to moderate. \n Wave: 1-3 ft.",
				},
				{
					title: t("byNight"),
					description: "Slight to moderate. \n Wave: 1-3 ft.",
				},
			],
		},
	];
};
